import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { FrontFirstTreeResponse } from 'src/app/shared/components/front-first-permission-tree/front-first-permission-tree.types';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './crud-config';

@Injectable()
export class PermissionGroupService extends AbstractCrudService {
  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  /**
   * Catálogo agrupado (árvore Grupo→Subgrupo→granular, rótulos PT-BR) do
   * universo de permissões do TENANT — usado pelo seletor do editor de grupo
   * (ver PermissionGroupCesComponent). Bug staging corrigido: sem este
   * catálogo, o `<app-permission-selector>` caía sempre no fallback sintético
   * (cabeçalhos derivados do nome técnico do Controller em inglês).
   */
  public getCatalog(): Observable<{ groups: any[] }> {
    return this.httpClient.get<{ groups: any[] }>(
      `${API_PATH}${this.relativeUrl}/catalog`
    );
  }

  /**
   * Árvore "Por tela" (front-first) do TENANT: área do menu → tela → ação, já com os
   * `system_action_param.id` reais e recortada pelo own-only do ator (anti-escalação — o que o
   * ator não possui não vem). Os ids são os mesmos do Avançado; nada muda na gravação.
   * Compartilhado pelos consumidores do seletor (grupos, tipos de usuário, usuário, perfil).
   */
  public getFrontFirstTree(): Observable<FrontFirstTreeResponse> {
    return this.httpClient.get<FrontFirstTreeResponse>(
      `${API_PATH}${this.relativeUrl}/front-first-tree`
    );
  }

  public findByFilter(filterForm: any, pagination: any): Observable<any[]> {
    const params = {
      ...{ getRelation: 0, limit: 25, page: 0, filter: '' },
      ...pagination,
    };

    return this.httpClient.post<any[]>(
      `${API_PATH}${this.relativeUrl}/filter`,
      { ...filterForm, ...params }
    );
  }
}
